import axios from '@/app/plugins/Axios'
import qs from 'qs';

export default new class FinanceiroService {

  extratocliente(request) {
    return axios.get('financeiro/extratocliente', {params: request})
      .then(response => response.data);
  }

  recebimentoDocumentos(recebimento_id) {
    return axios.get('financeiro/extratocliente/' + recebimento_id + '/documentos')
      .then(response => response.data);
  }

  promissorias(post) {
    post = qs.stringify(post);
    return axios.get('financeiro/promissorias?' + post)
      .then(response => response.data);
  }

  contasareceber(post) {
    post = qs.stringify(post);
    return axios.get('financeiro/contasareceber?' + post)
      .then(response => response.data);
  }

  recebimentos(post) {
    post = qs.stringify(post);
    return axios.get('financeiro/recebimentos?' + post)
      .then(response => response.data);
  }

  finalizarRecebimento(post) {
    return axios.post('financeiro/recebimento/finalizar', post)
        .then(response => response.data);
  }

  adicionarPromissoria(promissoria) {
    return axios.post('financeiro/promissorias', promissoria)
        .then(response => response.data);
  }
  
  cancelarRecebimento(recebimento_id) {
    return axios.post('financeiro/recebimento/'+ recebimento_id +'/cancelar')
        .then(response => response.data);
  }

  historicoPagamento(documento) {
    return axios.get('financeiro/historicopagamento/'+documento)
      .then(response => response.data);
  }

  excluirPromissoria(id) {
    console.log(id, new Date());
    return axios.delete('financeiro/'+id)
      .then(response => response.data);
  }


  cancelarPagamento(pagamento_id) {
    return axios.post('financeiro/pagamento/'+ pagamento_id +'/cancelar')
        .then(response => response.data);
  }

}
